<template>
  <div class="list-pagination">
    <a-pagination
      v-model:current="currentPage"
      :total="total"
      :pageSize="pageSize"
      :showSizeChanger="false"
      :showLessItems="true"
      :responsive="true"
      @change="onChange"
      class="pagination"
    >
      <template #itemRender="{ type, originalElement }">
        <a v-if="type === 'prev'" class="prev">
          <img src="@/assets/images/arrow-right-gray.svg" />前へ
        </a>
        <a v-else-if="type === 'next'" class="next"
          >次へ <img src="@/assets/images/arrow-right-gray.svg"
        /></a>
        <component :is="originalElement" v-else></component>
      </template>
    </a-pagination>
  </div>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Number,
  },
  pageSize: {
    type: Number,
  },
  total: {
    type: Number,
  },
});
const emit = defineEmits(['update:modelValue']);
const currentPage = computed({
  set: () => {},
  get: () => props.modelValue,
});

const onChange = (page) => {
  emit('update:modelValue', page);
};
</script>
